import {
  clarityPerSecond,
  recomputeRates,
  resiliencePerSecond,
} from "@/game/model/balance";
import type { IdleState } from "@/game/model/idle-state";

export type TickResult = {
  state: IdleState;
  deltaSeconds: number;
};

export function applyIdleTick(state: IdleState, deltaSeconds: number): TickResult {
  if (deltaSeconds <= 0) {
    return { state, deltaSeconds: 0 };
  }

  const focusGain = state.focusPerSecond * deltaSeconds;
  const clarityGain = clarityPerSecond(state.focusPerSecond) * deltaSeconds;
  const resilienceGain =
    resiliencePerSecond(state.resources.clarity) * deltaSeconds;

  const next: IdleState = {
    ...state,
    resources: {
      focus: state.resources.focus + focusGain,
      clarity: state.resources.clarity + clarityGain,
      resilience: state.resources.resilience + resilienceGain,
    },
    lastTickAt: state.lastTickAt + deltaSeconds * 1000,
  };

  return { state: recomputeRates(next), deltaSeconds };
}

export function applyClick(state: IdleState): IdleState {
  const next: IdleState = {
    ...state,
    resources: {
      ...state.resources,
      focus: state.resources.focus + state.clickPower,
    },
    totalClicks: state.totalClicks + 1,
  };
  return recomputeRates(next);
}
